import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import * as moment from 'moment';
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config } from "../../../../../config";
import ReactTooltip from 'react-tooltip'

function Calendar() {
    const history = useHistory();
    const [filter, setFilters] = useState({
        type: 'month',
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD'),
    });

    const getCalendarData = (fetchInfo, successCallback, failureCallback) => {
        const temp = filter;
        temp.start = moment(fetchInfo.start).format('YYYY-MM-DD');
        temp.end = moment(fetchInfo.end).format('YYYY-MM-DD');

        fetch(`${config.apiUrl}/events/calendar?${new URLSearchParams(temp)}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : ''}`
            },
        })
            .then(response => response.json())
            .then(data => {
                setFilters(temp);
                successCallback(data.data);
            });
    }

    const handleEventClick = (data) => {
        history.push(`/admin/events/edit/${data.event._def.publicId}?calender`)
    }

    const handleEventPositioned = (info) => {
        return <>
            <i data-tip data-for={`event-${info.event.id}`}> {info.timeText} {info?.event?.title} </i>
            <ReactTooltip id={`event-${info.event.id}`} aria-haspopup='true'>
                <ul>
                    <li><strong>Title:</strong> {info?.event?.title}</li>
                    <li><strong>Start:</strong> {info?.event?.extendedProps?.start_date_time ? moment(info?.event?.extendedProps?.start_date_time).format('MM/DD/YYYY hh:mm A') : ''} </li>
                    <li><strong>End:</strong> {info?.event?.extendedProps?.end_date_time ? moment(info?.event?.extendedProps?.end_date_time).format('MM/DD/YYYY hh:mm A') : ''} </li>
                    {/* <li><strong>Description:</strong> <p dangerouslySetInnerHTML={{ __html: info?.event?.extendedProps?.detail }}></p> </li> */}
                </ul>
            </ReactTooltip>
        </>
    }

    return <>
        <div className="cs-event-cal">
            <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }}
                dateClick={(e) => {
                    history.push('events/add', { date: e.date });
                }}
                // editable={true}
                dayMaxEvents={true}
                events={
                    (fetchInfo, successCallback, failureCallback) => getCalendarData(fetchInfo, successCallback, failureCallback)
                }
                displayEventEnd={true}
                // eventContent={renderEvent}
                eventClick={handleEventClick}
                eventContent={handleEventPositioned}
            />
        </div>
    </>
}

export default withRouter(Calendar);